export default __webpack_public_path__ + "static/media/Report-Active.cf9beff9.svg";